// Component imports
import {
  UploadOutlined, DownloadOutlined
} from '@ant-design/icons';
import { TranslationsIcon } from '../components/Icons/TranslationsIcon';
import { API_TAGS } from './api';

export const EXPORT_TABLE_ENTITIES = {
  FLOWS: {
    key: 'flows',
    tabLabel: 'Flows',
    tableLabel: 'Flow'
  }
  // ,
  // AUTOMATED_ANSWERS: {
  //   key: 'automated-answers',
  //   tabLabel: 'Automated Answers',
  //   tableLabel: 'Automated Answers'
  // }
};

export const EXPORT_RADIO_OPTIONS = {
  SELECT_ALL: {
    key: 'select-all',
    label: 'Select all Agent content'
  },
  SELECT_TABLE: {
    key: 'select-table',
    label: 'Select specific content'
  }
};

export const TRANSLATION_EXPORT_ALLOWED_NODE_TYPES = {
  MESSAGE: 'message',
  OPTION: 'option',
  QUESTION: 'select'
};

export const IMPORT_TRANSLATION_STATUS_TYPES = {
  NODE_DELETED: 'node-deleted',
  CONTENT_CHANGED: 'text-changed',
  ENTITY_DELETED: 'entity-deleted'
};

export const MANUAL_TRANSLATION_STEPS = {
  STEP_1: {
    labelProperties: {
      stepColumn: {
        stepLabel: 'STEP 1:',
        mainLabel: 'EXPORT',
        icon: <DownloadOutlined />
      },
      mainColumn: {
        title: 'Export Flows',
        description: 'Use this file (.pot or .csv) to create translations with any external translating tool.'
      }
    },
    priority: 1,
    key: 'step-1'
  },
  STEP_2: {
    labelProperties: {
      stepColumn: {
        stepLabel: 'STEP 2:',
        mainLabel: 'EXTERNAL TRANSLATION',
        icon: <TranslationsIcon />
      },
      mainColumn: {
        title: 'Translate Exported Flows',
        description: 'Use any external translating tool that supports (.pot or csv) files. Create translations for any available agent language.'
      }
    },
    priority: 2,
    key: 'step-2'
  },
  STEP_3: {
    labelProperties: {
      stepColumn: {
        stepLabel: 'STEP 3:',
        mainLabel: 'IMPORT',
        icon: <UploadOutlined />
      },
      mainColumn: {
        title: 'Import Translated Flows',
        description: 'Accepted file types: .zip (with .po only), .po, .csv. If multiple .po files then .zip is recommended. New translated Agent content will replace any existing content in each language.'
      }
    },
    priority: 3,
    key: 'step-3'
  }
};

export const TRANSLATION_FILE_TYPES = {
  CSV: {
    extension: '.csv',
    label: 'CSV',
    key: 'csv',
    allowedExport: true,
    allowedImport: true
  },
  ZIP: {
    extension: '.zip',
    label: 'ZIP',
    key: 'zip',
    allowedExport: false,
    allowedImport: true
  },
  PO: {
    extension: '.po',
    label: 'PO',
    key: 'po',
    allowedExport: false,
    allowedImport: true
  },
  POT: {
    extension: '.pot',
    label: 'POT',
    key: 'pot',
    allowedExport: true,
    allowedImport: false
  }
};

export const TRANSLATION_REFERENCES_COLUMN = 'ID';

export const TRANSLATIONS_INVALIDATED_TAGS = {
  'flows': API_TAGS.ACTIVITIES,
  'automated-answers': API_TAGS.AUTOMATED_ANSWERS
};

export const FILE_MIME_TYPES = {
  csv: 'text/csv;charset=utf-8;',
  pot: 'text/plain;charset=utf-8',
  po: 'text/plain;charset=utf-8;'
};

export const UTF_8_CHARSET = 'utf-8';
